const subListing = (course) => {
  const { topic, name, forPlus, description, link } = course;
  return [
    {
      hasCourseInstance: {
        '@type': 'CourseInstance',
        courseMode: 'Online'
      },
      '@id': link,
      about: {
        name: topic
      },
      '@context': 'http://schema.org',
      isAccessibleForFree: forPlus
        ? 'http://schema.org/False'
        : 'http://schema.org/True',
      name,
      provider: {
        '@type': 'Organization',
        name: 'Unacademy'
      },
      '@type': 'Course',
      description
    }
  ];
};

export default subListing;
